import { Reducer } from 'redux';
import { put, takeLatest, call } from 'redux-saga/effects';

import { TAppActions } from '../rootDuck';

import { ActionsUnion, createAction } from '../../utils/action-helper';
import { IServerResponse } from '../../interfaces/server';
import { IDoc } from '../../interfaces/docs';
import { getPublicDoc } from '../../crud/docs.crud';
import { getResponseMessage } from '../../utils/utils';

const FETCH_REQUEST = 'agreement/FETCH_REQUEST';
const FETCH_SUCCESS = 'agreement/FETCH_SUCCESS';
const FETCH_FAIL = 'agreement/FETCH_FAIL';

export interface IInitialState {
  agreement: IDoc | undefined;
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: IInitialState = {
  agreement: undefined,
  loading: false,
  success: false,
  error: null,
};

export const reducer: Reducer<IInitialState, TAppActions> = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REQUEST: {
      return {
        ...state,
        agreement: undefined,
        loading: true,
        success: false,
        error: null,
      };
    }

    case FETCH_SUCCESS: {
      return { ...state, agreement: action.payload.data, loading: false, success: true };
    }

    case FETCH_FAIL: {
      return { ...state, loading: false, error: action.payload };
    }

    default:
      return state;
  }
};

export const actions = {
  fetchRequest: (payload: string) => createAction(FETCH_REQUEST, payload),
  fetchSuccess: (payload: IServerResponse<IDoc>) => createAction(FETCH_SUCCESS, payload),
  fetchFail: (payload: string) => createAction(FETCH_FAIL, payload),
};

export type TActions = ActionsUnion<typeof actions>;

function* fetchSaga({ payload }: { payload: string }) {
  try {
    const { data }: { data: IServerResponse<IDoc> } = yield call(() =>
      getPublicDoc('user_agreement', payload)
    );
    yield put(actions.fetchSuccess(data));
  } catch (e) {
    yield put(actions.fetchFail(getResponseMessage(e.response.data.message)));
  }
}

export function* saga() {
  yield takeLatest<ReturnType<typeof actions.fetchRequest>>(FETCH_REQUEST, fetchSaga);
}
